import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { Box } from '@mui/material'
import { BooleanIcon } from 'components/core-ui/BooleanIcon'
import { BooleanIconText } from 'components/core-ui/BooleanIconText'
import { MultivalueCell } from 'components/core-ui/MultivalueCell'
import { ApproveFileWhite, DeleteFileRed, FileBlack } from 'icons'

export const getColumns = () => [
  {
    title: 'Nr. raport',
    field: 'reportNo',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Locatie',
    field: 'storeName',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Data',
    field: 'creationDate',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Categorii',
    field: 'wasteCategoryNames',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    render: (row: any) => <MultivalueCell value={row.wasteCategoryNames} size={1} />
  },
  {
    title: 'Transportator',
    field: 'carrier',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Destinatar',
    field: 'companyName',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Status predare',
    field: 'isHandedOver',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '120px',
    render: (row: any) => (
      <Box style={{ display: 'flex' }}>
        <BooleanIcon
          value={row.isHandedOver}
          icon="CheckCircleOutline"
          onFailure="#E5E5E5"
          onSuccess="#33691E"
        />
      </Box>
    )
  },
  {
    title: 'Doc',
    field: 'documentNo',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '80px',
    render: (row: any) => (
      <BooleanIconText
        value={row.documentNo}
        successIcon={<ApproveFileWhite />}
        failureIcon={<DeleteFileRed />}
        neutralIcon={<FileBlack />}
        isSuccess={row.isHandedOver}
        isFailure={!row.isHandedOver && row.documentNo === 0}
        isNeutral={!row.isHandedOver && row.documentNo > 0}
      />
    )
  }
]

export const getFilters = (wasteCategoryOptions: AutocompleteOption[]) => [
  {
    name: 'startDate',
    value: null,
    filter: <DatePicker label="Data inceput" variant="outlined" value={null} onChange={() => {}} />,
    type: 'date',
    label: 'Data inceput'
  },
  {
    name: 'endDate',
    value: null,
    filter: <DatePicker label="Data sfarsit" variant="outlined" value={null} onChange={() => {}} />,
    type: 'date',
    label: 'Data sfarsit'
  },
  {
    name: 'categories',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Categorii"
        options={wasteCategoryOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Categorii'
  },
  {
    name: 'reportNo',
    label: 'Nr. raport',
    type: 'text',
    filter: <Input type="text" name="reportNo" label="Nr. raport" variant="outlined" value="" />
  }
]
